// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UALADSActiveProgram } from './UALADSActiveProgram';
import {
    UALADSActiveProgramFromJSON,
    UALADSActiveProgramFromJSONTyped,
    UALADSActiveProgramToJSON,
    UALADSActiveProgramToJSONTyped,
} from './UALADSActiveProgram';

/**
 * ProgramManager with ActiveProgram from OPC UA LADS ProgramManagerType.
 * @export
 * @interface UALADSFunctionalUnitProgramManager
 */
export interface UALADSFunctionalUnitProgramManager {
    /**
     * 
     */
    activeProgram?: UALADSActiveProgram;
}

/**
 * Check if a given object implements the UALADSFunctionalUnitProgramManager interface.
 */
export function instanceOfUALADSFunctionalUnitProgramManager(value: object): value is UALADSFunctionalUnitProgramManager {
    return true;
}

export function UALADSFunctionalUnitProgramManagerFromJSON(json: any): UALADSFunctionalUnitProgramManager {
    return UALADSFunctionalUnitProgramManagerFromJSONTyped(json, false);
}

export function UALADSFunctionalUnitProgramManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UALADSFunctionalUnitProgramManager {
    if (json == null) {
        return json;
    }
    return {
        
        'activeProgram': json['activeProgram'] == null ? undefined : UALADSActiveProgramFromJSON(json['activeProgram']),
    };
}

export function UALADSFunctionalUnitProgramManagerToJSON(json: any): UALADSFunctionalUnitProgramManager {
    return UALADSFunctionalUnitProgramManagerToJSONTyped(json, false);
}

export function UALADSFunctionalUnitProgramManagerToJSONTyped(value?: UALADSFunctionalUnitProgramManager | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeProgram': UALADSActiveProgramToJSON(value['activeProgram']),
    };
}

